import { render } from "./vimeo.vue?vue&type=template&id=4795d384"
import script from "./vimeo.vue?vue&type=script&lang=js"
export * from "./vimeo.vue?vue&type=script&lang=js"

import "./vimeo.vue?vue&type=style&index=0&id=4795d384&lang=scss"

import exportComponent from "/builds/front-end/site-cms/deploy_site_cdn/site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__loftyFile', 'src/components/global/videos/_components/vimeo.vue'],['render',render],['__file',"vimeo.vue"]])

export default __exports__